/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component, EventEmitter, Input, Output, inject} from '@angular/core';

import {IxModule, ToastService} from '@siemens/ix-angular';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {BatteryPassAttributeLabel} from '../../../../../models/BatteryPassAttributeLabel';
import {FormFieldAttribute} from '../../../../../models/FormCategory';
import {AssignmentService} from '../../../../../services/assignment.service';

@Component({
  selector: 'app-assignment-details',
  imports: [IxModule, TranslateModule],
  templateUrl: './assignment-details.component.html',
  styleUrl: './assignment-details.component.scss',
})
export class AssignmentDetailsComponent {
  readonly assignmentService = inject(AssignmentService);
  readonly translate = inject(TranslateService);
  readonly toastService = inject(ToastService);

  @Input() assignmentPaneData?: BatteryPassAttributeLabel | null;
  @Input() attribute!: FormFieldAttribute;
  @Input() batteryPassId!: string;
  @Output() removedAssignment = new EventEmitter<BatteryPassAttributeLabel>();

  async onRemoveAssignmentClick() {
    if (this.assignmentPaneData) {
      this.removedAssignment.emit(this.assignmentPaneData);
      this.assignmentPaneData = null;
    }
  }

  async onRemindAssignmentClick() {
    const id = this.assignmentPaneData?.id;
    if (id) {
      await this.onReminderSent(id);
    }
  }

  async onReminderSent(assignmentId: string) {
    try {
      await this.assignmentService.sendReminder(assignmentId);

      this.translate
        .get('battery_pass.edit.attribute_assignments_pane.re_request_success')
        .subscribe((msg) => {
          this.toastService.show({message: msg, type: 'success'});
        });
    } catch {
      this.translate
        .get('battery_pass.edit.attribute_assignments_pane.re_request_error')
        .subscribe((msg) => {
          this.toastService.show({message: msg, type: 'error'});
        });
    }
  }
}
